import { CurrencyPipe, TitleCasePipe } from "@angular/common";
import { DatePipe } from "@angular/common";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { type ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, inject, provideAppInitializer } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { JWT_OPTIONS, JwtHelperService } from "@auth0/angular-jwt";
import { AngularSvgIconModule } from "angular-svg-icon";
import { MessageService } from "primeng/api";
import { routes } from "./app.routes";
import { tokenInterceptor } from "./core/interceptor/token.interceptor";
import { CurrencyPipeWrapper } from "./core/pipe/currency-pipe-wrapper.service";
import { EnumPipe } from "./core/pipe/enum.pipe";
import { TranslationService } from "./core/services/translation.service";
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { Theme } from './theme';

// export function InitializeApplication(merchantService: MerchantsService): () => Observable<Merchant[]> {
//     const observables = [merchantService.checkSyncStatus()];
//     const $forkJoin = forkJoin(observables);
//     return () => $forkJoin;
// }

// export function InitializeApplication(merchant:MerchantsService,authService:AuthService):()=>Observable<any>{
//     return ()=>merchant.loadMerchant(authService.getMerchantId());
// }

export function InitializeApp(
	translation: TranslationService,
): () => Promise<any> {
	return () =>
		translation
			.setTranslations(localStorage.getItem("locale") ?? "en-US")
			.then(() => console.log("Translations applied"));
}
export const appConfig: ApplicationConfig = {
	providers: [
		provideAppInitializer(() => {
        const initializerFn = (InitializeApp)(inject(TranslationService));
        return initializerFn();
      }),
		providePrimeNG({ 
		theme: {
			preset: Theme,
        options: {
          darkModeSelector: 'none',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng,customPrimeng,generic, tailwind-utilities',
          },
        },			
		}
		}),	  
		importProvidersFrom(AngularSvgIconModule.forRoot()),
		{ provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
		JwtHelperService,
		provideRouter(routes, withComponentInputBinding()),
		provideAnimations(),
		provideHttpClient(withInterceptors([tokenInterceptor])),
		provideZoneChangeDetection({ eventCoalescing: true }),
		DatePipe,
		CurrencyPipeWrapper,
		CurrencyPipe,
		EnumPipe,
		MessageService,
		TitleCasePipe,
	],
};
